import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {NotificationsModelService} from '../../Models/Notifications/notifications-model.service';
import {NotificationsGroupsModelService} from '../../Models/Notifications/notifications-groups-model.service';
import {NotificationsConfigModelService} from '../../Models/Notifications/notifications-config-model.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: NotificationsModelService,
    public modelGroups: NotificationsGroupsModelService,
    public modelConfig: NotificationsConfigModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las notificaciones
   *
   */
  public getNotifications(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getNotificaciones', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los grupos de notificación
   *
   */
  public getNotificationsGroups(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getGruposNotificaciones', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.modelGroups.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Marcar todas las notificaciones vistas
   *
   */
  public setSeenAllNotifications(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setNotificacionesVistas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar todas las notificaciones
   *
   */
  public deleteAllNotifications(params: { id?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteNotificaciones', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar la notificación
   *
   */
  public deleteNotification(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteNotificacion', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Marcar vista la notificación
   *
   */
  public seenNotification(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('toggleNotificacion', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar token de la notificación
   *
   */
  public setPushTokenNotification(params: { push: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPushToken', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener la configuración de las notificaciones
   *
   */
  public getNotificationsConfig(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getConfigNotificaciones').subscribe({
        next: (response) => {
          if (save) {
            this.modelConfig.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar nueva configuración de notificaciones
   *
   */
  public setNotificationsConfig(params: { id_notificacion: number, value: boolean }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setUserNotification', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
